import './style.css'
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Badge, Button, Container, Nav, NavDropdown, Navbar, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { loadFromLocalStorage, removeToLocalStorage, saveToLocalStorage } from '../../utils/LocalStorageUtils';
import ToggleSwitchLanguage from './toggleswitchcustom';
import { BsBellFill } from 'react-icons/bs';
import { apiCall } from 'utils/httpClient';
import apiEndPoint from 'utils/apiEndPoint';
import languages from 'translations';
import AIcons1 from './35.png';
import AIcons2 from './36.png';
import AIcons3 from './37.png';
import AIcons4 from './38.png';
import AIcons5 from './39.png';
import AIcons6 from './40.png';

function Header() {
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  const location = useLocation();
  const currentPath = location.pathname;
  const [languageData, setLanguageData] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  // const isActive = (path) => currentPath === path;
  const isActive = (path) => currentPath.startsWith(path);
  // Define the gradient styles
  const gradientStyle = {
    background: 'linear-gradient(45deg, #FF966a, #fff)', // Gradient colors
    border: 'none', // No border
    color: 'white', // Text color
    padding: '0px 20px', // Padding around the text
    fontWeight: 'bold', // Font size
    border: '0.5px solid #FF671F',
    // borderRadius: '50px', // Rounded corners
    cursor: 'pointer', // Pointer cursor on hover
    transition: 'background 0.3s ease', // Smooth transition
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true); // Add shadow after scrolling
      } else {
        setScrolled(false); // Remove shadow if at the top
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [notifications, setNotifications] = useState([
    // { id: 1, message: "New comment on your post", read: false },
    // { id: 2, message: "You have a new follower", read: true },
    // { id: 3, message: "System maintenance scheduled", read: false },
  ]);
  const pathname = window.location.pathname;


  async function getNotification() {
    const { data } = await apiCall("get", apiEndPoint.GETNOTIFICATION);
    if (data.status === 200) {
      setNotifications(data.data);
    } else {
      setNotifications([]);
    }
  }

  useEffect(() => {
    getNotification()
  }, [])

  useEffect(() => {
    if (pathname !== '/templateform') {
      saveToLocalStorage("selectTemplate", null);
      saveToLocalStorage("selectOrderDetail", null);
    }
  }, [])

  // const markAsRead = (id) => {
  //   setNotifications((prev) =>
  //     prev.map((notif) =>
  //       notif.id === id ? { ...notif, read: true } : notif
  //     )
  //   );
  // };

  const markAsUnread = async (id) => {

    const { data } = await apiCall("post", apiEndPoint.NOTIFICATIONSTATUSUPDATE, { notification_id: id });
    if (data.status === 200) {
      setNotifications((prev) => prev.map((notif) => notif._id === id ? { ...notif, is_seen: true } : notif));
    }
  };
  const markAsAllRead = async () => {
    const { data } = await apiCall("post", apiEndPoint.DELETEALLNOTIFICATION, { status: 'deleteAll' });
    if (data.status === 200) {
      setNotifications([]);
    }
  };

  const unreadCount = notifications.filter((n) => !n.is_seen).length;


  // Define the hover gradient styles
  const gradientHoverStyle = {
    background: 'linear-gradient(45deg, #feb47b, #ff7e5f)', // Inverted gradient on hover
  };
  const button2Ref = useRef(null);
  const handleOpenTab = () => {
    if (window.innerWidth < 990) {

      if (button2Ref.current) {
        button2Ref.current.click();
      }
    }
  }
  const handleLanguageChange = (lang) => {
    if (window.innerWidth < 990) {
      if (lang != undefined && lang != "") {
        if (lang === 'Hi') {
          const lang = {
            language: languages.hindiLang,
            langCode: 'hi',
          }
          saveToLocalStorage("SELECTLANGUAGE", lang);
        } else {
          const lang = {
            language: languages.english,
            langCode: 'en',
          }
          saveToLocalStorage("SELECTLANGUAGE", lang);
        }

      }
    }
  }


  // Combine default styles with hover styles using React state
  const [hover, setHover] = React.useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  let timeoutId;
  const handleMouseEnter = () => {
    clearTimeout(timeoutId);
    setShowDropdown(true);
  };
  const handleMouseLeave = (item = '') => {
    console.log('viiiiiiiiiiiiiiiii')
    setShowDropdown(false)
    // timeoutId = setTimeout(() => setShowDropdown(false), 1000); // 150ms delay
  };

  return (
    <Fragment>
      <Navbar expand="lg" sticky="top" className={`bg-white ${scrolled ? 'cstheader-shadow' : ''}`}>
        <Container>
          <Navbar.Brand
            href='/'
          >
            <img
              src="./assets/images/logodigitall.png"
              width={'150px'}
              height="100"
              className="d-inline-block align-top"
              // className="w-50"
              alt="bnr-img"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} ref={button2Ref} />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="start"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                <Link className='nav-link' onClick={() => handleOpenTab()} to='/'>
                  <img
                    src="./assets/images/logodigitall.png"
                    width={'150px'}
                    height="100"
                    className="d-inline-block align-top"
                    // className="w-50"
                    alt="bnr-img"
                  />
                </Link>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div style={{ marginLeft: '1rem' }} />
              <Nav
                className="me-auto borderradius-headercst"
                navbarScroll
                style={{
                  ...(hover ? { ...gradientStyle, ...gradientHoverStyle } : gradientStyle),
                  padding: 0
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
              >
                {/* <NavDropdown
                  className="pr-2 py-2 align-text-top"
                  title="Creation"
                  id="basic-nav-dropdown"
                >
                  <div className="container-fluid">
                    <div className="row w-100">
                      <div className="col-lg-6 col-12 text-left">
                        <Dropdown.Item onClick={() => {
                          navigate("/categories");
                        }}>
                          <h6>Website Design</h6>
                          <a className="tt-mute" role="button">
                            Discover all the ways you can create and design your
                            website on My Digital India App .
                          </a>
                        </Dropdown.Item>
                      </div>
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown
                  className="pr-2 py-2 align-text-top"
                  title="Business"
                  id="basic-nav-dropdown"
                >
                  <div className="container eventsNav pt-0 mt-0">
                    <div className="row">
                      <div className="col-lg-12 text-left">
                        <Dropdown.Header>
                          Catering
                        </Dropdown.Header>
                        <Dropdown.Item>
                          <span
                            onClick={() => {
                              navigate("/categories");
                            }}
                          >
                            <a className="nav-link" role="button">
                              Corporate
                            </a>
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <span
                            onClick={() => {
                              navigate("/categories");
                            }}
                          >
                            <a className="nav-link" role="button">
                              Private
                            </a>
                          </span>
                        </Dropdown.Item>

                        <Dropdown.Divider />
                        <Dropdown.Header>
                          Classes
                        </Dropdown.Header>
                        <Dropdown.Item>
                          <span
                            onClick={() => {
                              navigate("/about");
                            }}
                          >
                            <a className="nav-link" role="button">
                              Barista 101
                            </a>
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <span
                            onClick={() => {
                              navigate("/about");
                            }}
                          >
                            <a className="nav-link" role="button">
                              History of Coffee
                            </a>
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <span
                            onClick={() => {
                              navigate("/about");
                            }}
                          >
                            <a className="nav-link" role="button">
                              Intro to Cafe Snobbery
                            </a>
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Divider className="d-md-none" />
                      </div>
                    </div>
                  </div>
                </NavDropdown> */}
                {/* <span className="dividr-space"> | </span> */}
                <Link className='nav-link' onClick={() => handleOpenTab()} to='/'>{languageData?.home}</Link>
                {/* {authData?.userDetail && (<Link className='nav-link' to='/about'>About</Link>)} */}
                {/* {authData?.userDetail && (<Link className='nav-link' to='/categories?is_favourite=true'>Saved Templates</Link>)} */}
                <Link className='nav-link' onClick={() => handleOpenTab()} to='/about'>{languageData?.aboutUs}</Link>
                <Link className='nav-link' onClick={() => handleOpenTab()} to='/ourtemplate'>{languageData?.ourTemplates}</Link>
                <Link className='nav-link' onClick={() => handleOpenTab()} to='/our-mission'>{languageData?.ourMission}</Link>
                <Link className='nav-link' onClick={() => handleOpenTab()} to="/showcase">{languageData?.showcase}</Link>
              </Nav>
              {authData?.userDetail ?
                <>
                  <div className="d-flex align-items-center jst-tt gutter-space-2">
                    <span className="dividr-space" onClick={() => handleLanguageChange('En')} >En</span>
                    <ToggleSwitchLanguage />
                    <span className="dividr-space__" style={{ margin: '0 0.3rem' }} onClick={() => handleLanguageChange('Hi')}>ही</span>
                    <span className="dividr-space"> | </span>
                    <Navbar>
                      <Navbar.Toggle aria-controls="basic-navbar-nav" id='toggleButton' />
                      <Nav>
                        {/* Notifications Dropdown */}
                        <div className="bell-notification-wrapper">
                          <NavDropdown
                            className="nav-item dropdown"
                            title={
                              <span style={{ margin: 0, padding: 0, position: 'relative', display: 'inline-block' }}>
                                <BsBellFill style={{ margin: 0, padding: 0 }} />
                                {unreadCount > 0 && (
                                  <Badge
                                    style={{
                                      fontSize: '8px',
                                      fontWeight: 400,
                                      position: 'absolute',
                                      top: -4,
                                      right: -6,
                                      padding: '2px 5px',
                                      lineHeight: 1,
                                    }}
                                    bg="secondary"
                                  >
                                    {unreadCount}
                                  </Badge>
                                )}
                              </span>
                            }
                            id="notification-dropdown"
                            align="end"
                          >
                            {/* ...dropdown content... */}

                            {notifications.length > 0 ? (notifications.map((notification) => (
                              <div style={{ padding: '8px 16px' }}>
                                <div style={{ borderBottom: '1px solid #ff966a', cursor: 'pointer' }}
                                  key={notification.id}
                                  className="d-flex align-items-center justify-content-between p-0"
                                >
                                  <div>
                                    <span
                                      style={{
                                        textDecoration: notification.read
                                          ? "none"
                                          : "none",
                                        fontSize: 13,
                                        marginRight: 10
                                      }}
                                    >
                                      {notification.description}
                                    </span>
                                  </div>
                                  <div>
                                    {!notification.is_seen ? (
                                      <Button
                                        style={{ border: 'none', width: 'fit-content', fontSize: 12, background: 'transparent', color: '#ff966a', fontWeight: 500 }}
                                        size='sm'
                                        onClick={() => markAsUnread(notification._id)}>
                                        {languageData?.unread}
                                      </Button>
                                    ) : (
                                      // <Button
                                      // style={{ border: 'none', width: 'fit-content', fontSize: 12, background: 'transparent', color: '#ff966a', fontWeight: 400 }}
                                      // size='sm' variant="outline"
                                      //   onClick={() => markAsUnread(notification.id)}>
                                      //   {languageData?.markRead}
                                      // </Button>
                                      <></>
                                    )
                                    }
                                  </div>
                                </div>
                              </div>
                            ))
                            ) : (
                              <div className="px-1 text-center">{languageData?.noNotifications}</div>
                            )}
                            <div style={{ textAlign: 'end', marginRight: '11px' }}>
                              {notifications.length > 0 &&
                                <Button
                                  onClick={() => markAsAllRead()}
                                  style={{ border: 'none', fontSize: 12, background: 'transparent', color: '#ff966a', fontWeight: 500 }}
                                  size='sm'> Clear All
                                </Button>
                              }
                            </div>
                          </NavDropdown>
                        </div>
                      </Nav>
                      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ height: '39px' }}>
                        <NavDropdown
                          show={showDropdown}
                          align="end"
                          id="basic-nav-dropdown"
                          title={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '8px' }}>
                              {authData?.userDetail?.user_name && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      color: '#000',
                                      maxWidth: '80px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      display: 'inline-block',
                                    }}
                                    title={authData?.userDetail?.user_name}
                                  >
                                    {authData?.userDetail?.user_name}
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="#ff671f"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    style={{ color: '#ff671f' }}
                                  >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                  </svg>
                                </div>
                              )}

                              <img
                                width="20px"
                                style={{ borderRadius: 8 }}
                                src={
                                  authData?.userDetail?.profile_image
                                    ? authData?.userDetail?.profile_image
                                    : 'https://cdn-icons-png.flaticon.com/512/1144/1144760.png'
                                }
                                alt="user"
                              />
                            </div>
                          }
                        >
                          <NavDropdown.Item onClick={() => { handleOpenTab(); navigate("/myaccount"); }}
                            className={`cst-colorchange ${isActive("/myaccount") ? "active-nav-item" : ""}`}>
                            <div style={{
                              paddingBottom: '10px',
                              borderBottom: '1px solid #ff966a',
                              cursor: 'pointer',
                              backgroundColor: isActive("/myaccount") ? "#fff" : "transparent",
                              color: isActive("/myaccount") ? "#ff671f" : "inherit",
                              fontWeight: isActive("/myaccount") ? "600" : "normal"
                            }}>
                              <img src={AIcons1} alt="icon" style={{ marginRight: '10px', width: 16 }} />
                              {languageData?.accountSetting}
                            </div>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            onClick={() => { handleOpenTab(); navigate("/myorders/"); }}
                            className={`cst-colorchange ${isActive("/myorders") ? "active-nav-item" : ""}`}
                          >
                            <div
                              style={{
                                paddingBottom: '10px',
                                borderBottom: '1px solid #ff966a',
                                cursor: 'pointer',
                                backgroundColor: isActive("/myorders") ? "#fff" : "transparent",
                                color: isActive("/myorders") ? "#ff671f" : "inherit",
                                fontWeight: isActive("/myorders") ? "600" : "normal"
                              }}
                            >
                              <img src={AIcons2} alt="icon" style={{ marginRight: '10px', width: 16 }} />
                              {languageData?.myOrder}
                            </div>
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            onClick={() => { handleOpenTab(); navigate("/managetemplate"); }}
                            className={`cst-colorchange ${isActive("/managetemplate") ? "active-nav-item" : ""}`}
                          >
                            <div
                              style={{
                                paddingBottom: '10px',
                                borderBottom: '1px solid #ff966a',
                                cursor: 'pointer',
                                backgroundColor: isActive("/managetemplate") ? "#fff" : "transparent",
                                color: isActive("/managetemplate") ? "#ff671f" : "inherit",
                                fontWeight: isActive("/managetemplate") ? "600" : "normal"
                              }}
                            >
                              <img src={AIcons3} alt="icon" style={{ marginRight: '10px', width: 16 }} />
                              {languageData?.manageYourTemplate}
                            </div>
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            onClick={() => { handleOpenTab(); navigate("/enquires"); }}
                            className={`cst-colorchange ${isActive("/enquires") ? "active-nav-item" : ""}`}
                          >
                            <div
                              style={{
                                paddingBottom: '10px',
                                borderBottom: '1px solid #ff966a',
                                cursor: 'pointer',
                                backgroundColor: isActive("/enquires") ? "#fff" : "transparent",
                                color: isActive("/enquires") ? "#ff671f" : "inherit",
                                fontWeight: isActive("/enquires") ? "600" : "normal"
                              }}
                            >
                              <img src={AIcons4} alt="icon" style={{ marginRight: '10px', width: 16 }} />
                              {languageData?.enquires}
                            </div>
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            onClick={() => { handleOpenTab(); navigate("/wishlist"); }}
                            className={`cst-colorchange ${isActive("/wishlist") ? "active-nav-item" : ""}`}
                          >
                            <div
                              style={{
                                paddingBottom: '10px',
                                borderBottom: '1px solid #ff966a',
                                cursor: 'pointer',
                                backgroundColor: isActive("/wishlist") ? "#fff" : "transparent",
                                color: isActive("/wishlist") ? "#ff671f" : "inherit",
                                fontWeight: isActive("/wishlist") ? "600" : "normal"
                              }}
                            >
                              <img src={AIcons6} alt="icon" style={{ marginRight: '10px', width: 15 }} />
                              {languageData?.wishlist}
                            </div>
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            onClick={() => { handleOpenTab(); removeToLocalStorage('AUTH_DATA'); navigate("/login"); }}
                            className={`cst-colorchange ${isActive("/login") ? "active-nav-item" : ""}`}
                          >
                            <div
                              style={{
                                cursor: 'pointer',
                                backgroundColor: isActive("/login") ? "#fff" : "transparent",
                                color: isActive("/login") ? "#ff671f" : "inherit",
                                fontWeight: isActive("/login") ? "600" : "normal"
                              }}
                            >
                              <img src={AIcons5} alt="icon" style={{ marginRight: '10px', width: 16 }} />
                              {languageData?.signOut}
                            </div>
                          </NavDropdown.Item>

                        </NavDropdown>
                      </div>
                    </Navbar>
                  </div>
                </>
                :
                <div className="d-flex align-items-center jst-tt gutter-space-2">
                  <span className="dividr-space__" style={{ margin: '0 0.3rem' }}>En</span>
                  <ToggleSwitchLanguage />
                  <span className="dividr-space__" style={{ margin: '0 0.3rem' }}>ही</span>
                  <span className="dividr-space"> | </span>
                  <Nav.Link href="/login" style={{ marginRight: '0.8rem' }}
                    className=""
                  >
                    {languageData?.logIn}
                  </Nav.Link>
                  <Button
                    href='/signup'
                    className="get-st-btn transition duration-300 ease-in-out transform hover:scale-105 hover:bg-blue-600"
                    style={{ width: '130px', fontSize: '14px' }}
                  >
                    {languageData?.getStarted}
                  </Button>
                </div>
              }
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </Fragment>
  );
}

export default Header;